import React, { Component } from 'react';
import { connect } from 'react-redux';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { withStyles } from '@material-ui/core';

import cellfind from "assets/img/cellfind.png";
import panacea from "assets/img/panacea.jpg";
import simigenix from "assets/img/simigenix.png";
import defaultProductImage from "assets/img/no_product.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faChevronCircleRight, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import CheckboxList from '../../components/List/CheckboxList';
import { ScrollToTop } from '../../layouts/Dashboard';
import Loading from '../../components/Loading/Loading';
import Api from '../../api/Api.js';
import EmailEndpoints from '../../api/EmailEndpoints';
import { store } from '../../redux/store';
import { push } from 'connected-react-router';

function getSteps() {
    return ['Pick Products', 'Pick Contact Type', 'Pick Cost Center'];
}

function StepContent(props) {
    return <div style={{ display: props.index === props.activeStep ? 'block' : 'none' }}>{props.children}</div>;
}

class NotifyCustomerEmail extends React.Component {

    state = {
        activeStep: 0,
        loading: false
    }

    handleNext = () => {
        if (this.state.activeStep === getSteps().length - 1) {
            //Finish

            this.setState({ loading: true }, async () => {
                var products = this.pickProducts.getListOfSelected().map(x => x.id);
                var contactTypes = this.pickContact.getListOfSelected().map(x => x.primary.toLowerCase());
                var companies = this.pickCompany.getListOfSelected().map(x => x.primary);

                const { data } = await Api.post(EmailEndpoints.customersToNotify, { products, contact_types: contactTypes, companies });
                store.dispatch(push('/emails/compose', { bcc: data }))
            });
        } else {
            this.setState({ activeStep: this.state.activeStep + 1 }, () => ScrollToTop && ScrollToTop());
        }
    }

    handleBack = () => this.setState({ activeStep: this.state.activeStep - 1 }, () => ScrollToTop && ScrollToTop());

    render() {
        const { classes } = this.props;

        return (
            <Card>
                <CardBody style={{ position: 'relative', overflow: 'hidden' }}>
                    {/* Loading Overlay */}
                    {
                        this.state.loading ?
                        <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, backgroundColor: 'rgba(255, 255, 255, 0.75)', zIndex: 1 }}>
                            <Loading />
                        </div> : null
                    }

                    <Stepper activeStep={this.state.activeStep}>
                        {getSteps().map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    <div>
                        <StepContent activeStep={this.state.activeStep} index={0}>
                            <CheckboxList
                                key="products"
                                ref={cbxlist => this.pickProducts = cbxlist}
                                data={this.props.products.map(product => ({ ...product, avatar: (product.image ? "/api/image/get?id=" + product.image : defaultProductImage), primary: product.name, secondary: product.description }))}
                            />
                        </StepContent>
                        <StepContent activeStep={this.state.activeStep} index={1}>
                            <CheckboxList
                                key="contacts"
                                ref={cbxlist => this.pickContact = cbxlist}
                                data={[
                                    { primary: 'Business' },
                                    { primary: 'Financial' },
                                    { primary: 'Technical' }
                                ]}
                            />
                        </StepContent>
                        <StepContent activeStep={this.state.activeStep} index={2}>
                            <CheckboxList
                                key="company"
                                ref={cbxlist => this.pickCompany = cbxlist}
                                data={[
                                    { avatar: cellfind, primary: 'Cellfind' },
                                    { avatar: panacea, primary: 'Panacea' },
                                    { avatar: simigenix, primary: 'Simigenix' }
                                ]}
                            />
                        </StepContent>
                        <div>
                            <Button disabled={this.state.activeStep === 0} onClick={this.handleBack}>
                                <FontAwesomeIcon icon={faChevronCircleLeft} />&nbsp;&nbsp;&nbsp;Back
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleNext}
                                style={{ float: "right" }}
                            >
                                {this.state.activeStep === getSteps().length - 1 ? 'Finish' : 'Next'}
                                &nbsp;&nbsp;&nbsp;
                                {this.state.activeStep === getSteps().length - 1 ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faChevronCircleRight} />}
                            </Button>
                        </div>
                    </div>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = ({ products }) => ({
    products: products.list
})

export default connect(mapStateToProps)(NotifyCustomerEmail);